import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import BrokenGlasses from "../components/ErrorPage/components/BrokenGlasses.js";
/* empty css               */
const ErrorPage = (props) => {
  const { getLabel } = useIntl();
  const {
    header = "Oops, something went wrong...",
    subheader,
    image = /* @__PURE__ */ React.createElement(BrokenGlasses, { ariaLabel: getLabel("common.errors.nonrecoverable.generic") }),
    buttonText,
    buttonHref
  } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "error-page" }, header && /* @__PURE__ */ React.createElement(Heading, { className: "error-page__header" }, header), subheader && /* @__PURE__ */ React.createElement("p", { className: "error-page__sub-header" }, subheader), image && /* @__PURE__ */ React.createElement("div", { className: "error-page__image" }, image), /* @__PURE__ */ React.createElement("div", { className: "error-page__buttons" }, buttonText && /* @__PURE__ */ React.createElement(Button, { caption: buttonText, href: buttonHref ?? "/", className: "error-page__button" })));
};
export {
  ErrorPage as default
};
//# sourceMappingURL=ErrorPage.js.map
